module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("I Fall to Pieces")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("There are really only two possible explanations here:")]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("1) Daphne lied to my face about the almonds in order to see me humiliated in front of the entire school.")]), _vm._v(" "), _c('p', {
    staticClass: "NL"
  }, [_vm._v("2) Daphne didn’t "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("know")]), _vm._v(" about the almonds.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As I stand in front of an entire gym of restless teenagers and try to block out the sounds of the final sophomore candidate’s speech, I scan the crowd for Daphne. Maybe I can deduce her motives (or lack thereof) by the smug (or clueless) expression on her face, but I can’t seem to find her. Instead, my eyes fall back on Owen, who’s pantomiming dramatically to get my attention. I squint, trying to decipher his movements. But, to be honest, they have more resemblance to some interpretive modern dance than actual sign language.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He’s either miming that his head is on fire or he’s asking me what on earth I’m going to do.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I reach up to touch my lips, hoping to gauge the severity of the reaction. Maybe there was only a trace of almonds. Maybe I can get my speech over with before my lips turn into full-blown whoopie pies.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But as soon as my fingers brush against the taut, swollen skin, I know I’m in trouble. I can definitely feel my lips on my fingers but I can’t feel my "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("fingers")]), _vm._v(" on my lips.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There’s a jab at my arm and Rhiannon is looking at me with bug eyes, as if to say “What’s the matter with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’re up,” she hisses.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("What?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I incline my head toward hers. “I can’t do this,” I try to whisper, but the words are garbled and clumsy.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Does she not see my lips? Does she not get how disastrous this is going to be?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She gives me a little shove. “Go.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As I slowly approach the microphone stand, I lock eyes with Owen once more. From the look on his face, I realize he can’t believe I’m going through with this.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("That makes two of us.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A snicker breaks out among the students. No doubt someone has noticed my inflated lips and is spreading the word swiftly.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I clasp my index cards in my hand and step up to the microphone.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Just keep it brief. Introduce yourself. Read some of the buzz words from the cards and then take cover.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I glance down at Rhiannon’s perfect girly handwriting. The ink seems to be running, like someone spilled water on it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Are my eyes swelling, too?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Hello,” I say into the microphone. I can hear the amplification through the gym’s speaker system. The word comes ricocheting back at me a split second later like a distorted boomerang. But it doesn’t sound like “hello,” it sounds like “he-wo.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The snickers instantly turn to giggles.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I take a deep breath. “My name is Ellison Sparks and I’m running for junior class vice president.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I cringe, waiting to hear what I really sound like. I only catch the tail end of the sentence. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Vife pwesheden.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This is it. This is the end. I always wondered how I was going to die. And silly me, I thought it would be something epic and tragically romantic. Like sharing a vial of poison with my star-crossed lover. I never thought it would end like this.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Metaphorically stoned by my peers.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Murdered by my own kin.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I rush through the rest of the speech as fast as I can, trying to focus on moving my thick, dragging lips while at the same time attempting to block out the echo of my voice reverberating back at me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The giggles have escalated to full-blown laughter now. I can feel Principal Yates’s muscular arms flapping somewhere behind me, trying to silence the growing unrest with wide sweeps of her hands, but it isn’t working.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I peer up at Tristan, hoping he’ll pass on some of that confidence he seems to possess so easily. He catches my eye and then looks away. That’s when it hits me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’m not just embarrassing myself. I’m embarrassing "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("him.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All those girls who doubted his sanity when he started dating me—who still doubt it—were right. What is he doing with me? I can’t even read a few words off an index card without making a fool of myself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At least he’s not laughing like everyone else.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At least there’s that.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Thank you for your attention and please vote for Marshall/Sparks for your junior class president and vice president.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I stuff the index cards back in my pocket and run from the gym. I don’t wait for applause. I know there won’t be any. But the laughter follows me down the hall.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7ed5e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter9.vue
// module id = 99
// module chunks = 0